import { HttpPromise } from "@shared/svelte/Modules/ApiService";
import PunchoutSessionStore from "@retailer/svelte/stores/PunchoutSessionStore";

const getPunchoutSession = () =>
  HttpPromise({
    method: "GET",
    url: "/api/retailer/punchout_session",
  });

export const loadPunchoutSession = async () => {
  const punchoutSession = await getPunchoutSession();
  PunchoutSessionStore.set(punchoutSession);
  return punchoutSession;
};
